(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay/assets/javascripts/utils/payment-logging.js') >= 0) return;  svs.modules.push('/components/tur/pay/assets/javascripts/utils/payment-logging.js');

'use strict';

function logPaymentResults(_ref) {
  let successfulTickets = _ref.successfulTickets,
    failedTickets = _ref.failedTickets,
    successfulWagers = _ref.successfulWagers,
    failedWagers = _ref.failedWagers;
  if (successfulWagers.length) {
    const successfulProducts = successfulWagers.map(_ref2 => {
      var _wager$bets, _wager$bets2;
      let wager = _ref2.wager;
      return ((_wager$bets = wager.bets) === null || _wager$bets === void 0 ? void 0 : _wager$bets.length) > 1 ? wager.bets.map(bet => bet.productId).join(' with ') : (_wager$bets2 = wager.bets) === null || _wager$bets2 === void 0 || (_wager$bets2 = _wager$bets2[0]) === null || _wager$bets2 === void 0 ? void 0 : _wager$bets2.productId;
    });
    svs.tur.pay.logger.info("Successfully paid ".concat(successfulWagers.length, " wager(s) (").concat(successfulProducts.join(' and '), ")"));
  }
  if (failedWagers.length) {
    const failedProducts = failedWagers.map(_ref3 => {
      var _wager$bets3, _wager$bets4;
      let wager = _ref3.wager;
      return ((_wager$bets3 = wager.bets) === null || _wager$bets3 === void 0 ? void 0 : _wager$bets3.length) > 1 ? wager.bets.map(bet => bet.productId).join(' with ') : (_wager$bets4 = wager.bets) === null || _wager$bets4 === void 0 || (_wager$bets4 = _wager$bets4[0]) === null || _wager$bets4 === void 0 ? void 0 : _wager$bets4.productId;
    });
    svs.tur.pay.logger.info("Failed to pay ".concat(failedWagers.length, " wager(s) (").concat(failedProducts.join(' and '), ")"));
  }
  if (successfulTickets.length) {
    const successfulTicketProducts = successfulTickets.map(_ref4 => {
      let product = _ref4.product;
      return product;
    });
    svs.tur.pay.logger.info("Successfully paid ".concat(successfulTickets.length, " ticket(s) (").concat(successfulTicketProducts.join(' and '), ")"));
  }
  if (failedTickets.length) {
    const failedTicketProducts = failedTickets.map(_ref5 => {
      let product = _ref5.product;
      return product;
    });
    svs.tur.pay.logger.info("Failed to pay ".concat(failedTickets.length, " ticket(s) (").concat(failedTicketProducts.join(' and '), ")"));
  }
}
svs.tur.pay.utils.logPaymentResults = logPaymentResults;

 })(window);